import { Controller } from "@hotwired/stimulus";
import FsLightbox from "fslightbox"; // Import FsLightbox directly

export default class extends Controller {
  connect() {
    this.initializeLightbox();

    document.addEventListener("turbo:load", this.initializeLightbox);
  }

  disconnect() {
    // This is necessary to prevent memory leaks
    document.removeEventListener("turbo:load", this.initializeLightbox);
  }

  initializeLightbox = () => {
    window.refreshFsLightbox();
  };
}
